module.exports = __webpack_public_path__ + "media/images/app/subscriptions/box-section-21b429c86b0b1c77e4f5fb377e425608.webp";